module.exports = __webpack_public_path__ + "static/media/logo.11d3a52c.svg";